import addIcon from 'assets/icons/plus-blue-16.svg';
import { FormApi } from 'final-form';
import React, { useContext, useState } from 'react';
import { LocaleContext, ModalForm, NotificationsContext, NotificationTypes } from 'shared';
import { AddCertificateField } from 'shared/certifications/addCertificateField/AddCertificateField';
import { AddCertificatePayload, AddCertificateResponse, CertificateType } from 'store/api/types';
import { getErrorMessage } from 'utils/getErrorMessage/getErrorMessage';

import { AddCertificateButton, AddCertificateWrapper } from './AddCertificate.styles';
import { AddCertificateProps } from './AddCertificate.types';

const LOCALE_PREFIX = 'CERTIFICATES.ADD.';

export const AddCertificate = ({
  applicationId,
  accountId,
  certificateType,
  onSubmitCallback,
  onAddCertificate,
}: AddCertificateProps) => {
  const localeContext = useContext(LocaleContext);
  const notificationsContext = useContext(NotificationsContext);
  const [formOpened, setFormOpened] = useState(false);
  const [fileName, setFileName] = useState('');

  const getLocaleText = (idPart: string) => {
    const certificateText = certificateType === CertificateType.QWAC ? 'QWAC' : 'QSealC';

    return localeContext.formatMessage({ id: `${LOCALE_PREFIX}${idPart}` }, { type: certificateText });
  };

  const handleFormClose = () => setFormOpened(false);
  const handleFormOpen = () => setFormOpened(true);
  const handleError = (response: any) => {
    notificationsContext.showNotification({
      message: getErrorMessage(response, localeContext),
      time: 4000,
      type: NotificationTypes.ERROR,
    });
  };
  const handleSubmit = async (values: any, form: FormApi) => {
    const payload = {
      certificate: values[`${certificateType}Certificate`],
      certificateType,
      fileName,
    } as AddCertificatePayload;

    return await onAddCertificate(accountId, applicationId, payload).then(
      (response: AddCertificateResponse) => {
        if (response.error) {
          handleError(response);
        } else {
          handleFormClose();

          notificationsContext.showNotification({
            message: getLocaleText('SUCCESS'),
            time: 1000,
            type: NotificationTypes.SUCCESS,
          });
          onSubmitCallback();
        }
      },
      error => handleError(error),
    );
  };

  return (
    <AddCertificateWrapper className="certificates-group__add-wrapper">
      <AddCertificateButton onClick={handleFormOpen} className="certificates-group__add-button">
        {getLocaleText('BUTTON.TEXT')}
        <img src={addIcon} alt={getLocaleText('BUTTON.TEXT')} />
      </AddCertificateButton>
      <ModalForm
        className="certificates-group__add-certificate-modal"
        name={getLocaleText('MODAL-NAME')}
        submitName={localeContext.formatMessage({ id: 'GENERAL.SAVE' })}
        isOpen={formOpened}
        onClose={handleFormClose}
        onSubmit={handleSubmit}
        initialValues={undefined}
      >
        <AddCertificateField certificateType={certificateType} setFileName={setFileName} />
      </ModalForm>
    </AddCertificateWrapper>
  );
};
